import CategoryForm from './CategoryForm'
import styles from './CategoryDetail.css'
import {submitForm, hideDeleteModal, deleteCategory} from 'actions/ingredients/category'
import {connect} from 'react-redux'
import {formValueSelector} from 'redux-form'
import ConfirmDeleteModal from 'components/LibraryDeleteModal'

class CategoryDetail extends React.Component {
  render () {
    const {showDeleteModal, categoryDetail} = this.props
    return <div className={styles.wrapper}>
      <CategoryForm onSubmit={this._onSubmit} />
      {!!categoryDetail && <ConfirmDeleteModal
        showDeleteModal={showDeleteModal}
        onHide={this._onHide}
        title='Category'
        name={categoryDetail.name}
        onDelete={this._onDelete}
      />}
    </div>
  }

  _onDelete = () => {
    const {dispatch, categoryDetail, categories} = this.props
    dispatch(deleteCategory(categoryDetail, categories))
  }

  _onHide = () => {
    this.props.dispatch(hideDeleteModal())
  }

  _onSubmit = (values) => {
    const createAllOutlet = values.action === 'save_to_all_outlet'
    const {categories, dispatch, search: {outletIds}} = this.props
    delete values.action
    dispatch(submitForm({ingredient_category: values}, createAllOutlet, categories, outletIds))
  }
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  const {categories, showDeleteModal, categoryDetail} = state.ingredients.category
  return {
    categories,
    categoryDetail,
    showDeleteModal,
    search: {
      outletIds: selector(state, 'outletIds')
    }
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(CategoryDetail)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Category/CategoryDetail/CategoryDetail.js